module.exports = __webpack_public_path__ + "img/Pot1.61e73d50.svg";